import React from "react"

import './utils/css/reset.css';
import './utils/css/variables.css';
import './utils/css/typography.css';
import './utils/css/commons.css';

import { motion } from "framer-motion"
import {isMobile} from 'react-device-detect';
/* import { useInView } from 'react-intersection-observer'; */

/* import List from './layouts/List/List' */
/* import Functionality from './layouts/Functionality/Functionality' */
/* import Video from './layouts/Video/Video' */
/* import Faq from './layouts/Faq/Faq' */
import Download from './layouts/Download/Download'
import Footer from './layouts/Footer/Footer'
import DownloadMobile from './components/DownloadMobile/DownloadMobile'

// Header assets
import logo from './utils/img/brandLogoNewMobileNegative.svg'
import hamburger from './utils/img/menu.svg'
import close from './utils/img/close.svg'

// Opening assets
/* import opening_image from './utils/img/imagemockup001.png' */
/* import app_store from './utils/img/appStoreBadgeUsBlack.svg' */
/* import google_play from './utils/img/googlePlayBadgeUs.svg' */

// Notiziario assets
/* import image01 from './utils/img/s2-devices2.png' */
/* import detail01 from './utils/img/s2-highlights1.png' */

// AgiSelect assets
/* import image02 from './utils/img/s3-device3.png' */

// MyAgi assets
/* import image03 from './utils/img/s4-devices1.png' */
/* import detail03 from './utils/img/s4-detail.svg' */

// Video assets
// import video from './utils/video/ZDUOPD_pompei-2000_8XDTVV.mp4'
// import play from './utils/img/play.svg'

// Download assets
import qrImage from './utils/img/QRCodeAGI.jpg'

function Landing() {

  {/* Variabili da aggiungere */}
  
  {/* MENU */}
  /* let codicePromo = `http://www.google.com`; */
  let faq = `https://api.agi.it/agiprima/static/faq.html`;
  let contattaci = `mailto:support.agiprima@agi.it`;

  {/* SCARICA L'APP */}
  let downloadAppLink = `http://onelink.to/97gsjt`;

  {/* SCARICA da APP STORE */}
  let appStoreLink = `https://apps.apple.com/it/app/agi-prima/id1544055522`;

  {/* SCARICA da GOOGLE PLAY */}
  let googlePlayLink = `https://play.google.com/store/apps/details?id=com.agi.b2c.android`;


  const [toggleMenu, setToggleMenu] = React.useState(false)

  const menuAnimation = {
    enter: {
      opacity: 1,
      transition: {
        duration: .2,
        type: `tween`
      },
      display: `flex`
    },
    exit: {
      opacity: 0,
      transition: {
        duration: .2,
        type: `tween`
      },
      transitionEnd: {
        display: 'none'
      }
    }
  }

  /* const leftElement = {
    start: {
         opacity: 0,
         x: -100,
         transition: {
          duration: .6,
          when: "beforeChildren",
          staggerChildren: 1
       }
       },
       end: {
        opacity: 1,
        x: 0,
        transition: {
          duration: .6,
          when: "beforeChildren",
          staggerChildren: 1
        }
       }
  } */

  /* const rightElement = {
    start: {
      opacity: 0,
      x: 100,
      transition: {
        duration: .6,
        when: "beforeChildren",
        staggerChildren: .1
     }
    },
    end: {
      opacity: 1,
      x: 0,
      transition: {
        duration: .6,
        when: "beforeChildren",
        staggerChildren: .1
     }
    }
  } */

  /* const isAppearing = {
    start: {
      opacity: 0,
      transition: {
        duration: .4
      }
    },
    end: custom => ({
      opacity: 1,
      transition: {
        duration: .4,
        delay: custom * .1
      }
    })
  } */

  return (
    <article className={`Landing`}>
      <div className={`header-wrapper`}>
        <header>
          <h1><a href={`https://www.agi.it`}><img src={logo} /></a></h1>
          <a className={`hamburger ${toggleMenu && `fixed`}`} onClick={event => setToggleMenu(!toggleMenu)}><img src={toggleMenu ? close : hamburger} /></a>

          <motion.nav 
            className={`${toggleMenu ? `is-opened` : `is-closed` }`}
            initial={!isMobile ? `enter` : `exit`}
            animate={toggleMenu ? `enter` : `exit`}
            variants={isMobile && menuAnimation}
          >
            <ul>
              
              <li><a href={faq} target={`_blank`}>FAQ</a></li>
              <li><a href={contattaci}>Contattaci</a></li>
            </ul>
           
            <a className={`download-button`} href={`#downloadSection`}> Scarica l'app</a>
           
          </motion.nav>
        </header>
      </div>

{/* Opening Section */}
      { /* <section className={`opening-wrapper`}>
          <div className={`opening`}>
            <div className={`opening-inner`}>
              <motion.div className={`opening-inner-content`} initial={`start`} animate={`end`} variants={leftElement}>
                  <div className={`content-body`}>
                      <h1 className={`title _title-big bold`}>Dalla Prima <br/>all'ultima notizia</h1>
                      <p className={`text _text-small`}>News, analisi, storie, fatti.<br/>Per averle ti basta uno smartphone.</p>
                      
                      <div className={`opening-download`}>
                            <motion.ul className={`store-buttons`} variants={isAppearing} custom={3} >
                                <li><a href={appStoreLink}><img src={app_store} alt={`App Store`} /></a></li>
                                <li><a href={googlePlayLink}><img src={google_play} alt={` Google Play`} /></a></li>
                            </motion.ul>

                            <p className={`_text-small italic`}>oppure</p>

                            <motion.div className={`download-inner-qrbox`} variants={isAppearing} custom={5}>
                                <img src={qrImage} />
                                <p className={`_text-small italic`}>Inquadra il qrcode con la fotocamera del tuo device.</p>
                            </motion.div>
                      </div>
                  </div>
              </motion.div>

              <motion.div className={`opening-inner-image`} initial={`start`} animate={`end`} variants={rightElement} >
                  <img src={opening_image} />
              </motion.div>
            </div>
          </div>
      </section> */}

{/* First Section */}
      { /* <List 
          mode={`light`}
          number={ `01` } 
          surtitle= { `Notiziario` }
          title= { `Prima il fatto e poi la notizia` }
          idImage={`l01`}
          deviceSource={image01}
          peculiarSource={detail01}
          variantsContent={rightElement}
          variantsImage={leftElement}
      >
        <p className={`_text`} >
        Un flusso costante e <strong>personalizzabile</strong> dei più importanti <strong>lanci da tutto il mondo.</strong> 
        </p>
      </List> */}

{/* Second Section */}
      { /* <List 
          mode={`dark`}
          number={ `02` } 
          surtitle= { `Agi select` }
          title= { `Quello che conta. Mappa e bussola. ` }
          idImage={`l02`}
          deviceSource={image02}
          variantsContent={leftElement}
          variantsImage={rightElement}
      >
        <p className={`_text`} >
          Ti guidiamo alla scoperta delle notizie da non perdere con una selezione di articoli che raccontano la storia <strong>sempre aggiornata.</strong> I fatti del presente per <strong>comprendere il domani.</strong>
        </p>
      </List> */}

{/* Third Section */}
      { /* <List 
          mode={`light`}
          number={ `03` } 
          surtitle= { `my agi` }
          title= { `Scegli tu cosa seguire e non perdere i temi che ti interessano. Filtra migliaia di notizie.` }
          idImage={`l03`}
          deviceSource={image03}
          peculiarSource={detail03}
          variantsContent={rightElement}
          variantsImage={leftElement}
      >
        <p className={`_text`} >
          Il tuo mix quotidiano di news personalizzate. <strong>La tua raccolta </strong>dei fatti che contano.
        </p>
      </List>

{/* Functionality Section */}
    { /* <Functionality /> */ }

{/* Video Section */}
    { /* <Video /> */ }


{/* FAQ Section */}
      { /* <Faq 
        link={faq}
        faqs={[
          {
            question: `Quali sono i contenuti di AGI Prima?`,
            answer: `L’app AGI Prima si compone di tre sezioni: Notiziario, AGI Select e My AGI. Il Notiziario è costituito dai lanci di agenzia, AGI Select è invece una scelta delle notizie fatta dalla redazione, My AGI è la sezione dei fatti scelti dai lettori in base ai suoi interessi.`
          },
          {
            question: `Cosa posso fare con la versione basic dell'app?`,
            answer: `Fatta salva l'ipotesi della prova gratuita, l'utente può accedere gratuitamente all’app in versione basic. Si tratta della versione limitata ad accesso gratuito che permette di consultare esclusivamente i titoli degli articoli della sezione “AGI Select”.`
          },
          {
            question: `Posso provare il servizio prima di sottoscrivere l’abbonamento?`,
            answer: `Si, è possibile provare il servizio senza sottoscrivere l'abbonamento usufruendo dell'opzione prova gratuita di 14 giorni. Con riferimento a tale opzione non sussiste un limite quantitativo di articoli che possono essere letti, ma è invece previsto un limite di tempo (14 giorni) terminato il quale è necessario sottoscrivere l'abbonamento mensile o annuale per leggere i contenuti. Ciascun utente potrà beneficiare del periodo di prova gratuita dell'app per una sola volta`
          },
          {
            question: `Cosa succede se perdo/se mi rubano lo smartphone?`,
            answer: `In questo caso è necessario scrivere all'assistenza clienti (support.agiprima@agi.it) che ti fornirà poi le istruzioni da seguire.`
          },
          {
            question: `Posso condividere l'abbonamento?`,
            answer: `No, l'abbonamento è personale, non cedibile e utilizzabile su un solo dispositivo alla volta.`
          },
          {
            question: `Come posso evitare il rinnovo automatico del mio abbonamento?`,
            answer: `Gli abbonamenti sono disponibili per periodi di validità minima diversi e si rinnovano automaticamente per lo stesso periodo selezionato, salva disdetta da parte dell’Utente. È in ogni caso sempre possibile evitare il rinnovo automatico dell'abbonamento ad AGI Prima dando disdetta con le modalità ed entro i termini previsti dalla piattaforma utilizzata dall’utente (App Store o Google Play). In caso di disdetta, potrai continuare a fruire del servizio AGI Prima fino alla data di scadenza originaria.`
          },

        ]}
      /> */ }

{/* Download Section */}
      <Download 
        appStore={appStoreLink} 
        googlePlay={googlePlayLink} 
        qrImage={qrImage}
      />

{/* Download Section */}
      <Footer />

{/* Sticky button Download Mobile */}
      <DownloadMobile link={downloadAppLink} />

    </article>
  );
}

export default Landing;
